module.exports = "/images/xSocialReverse.png?14e75322be1e6aaed25a6923ee51c053";